import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import s2 from "../assets/images_new/shuttle.webp";
import experienced from "../assets/images_new/experienced-drivers.webp";
import comfortable from "../assets/images_new/comfortable-vehicles.webp";
import tracking from "../assets/images_new/real-time-tracking.webp";
import eco from "../assets/images_new/eco.webp";
import ontime from "../assets/images_new/on-time.webp";
import reliable from "../assets/images_new/reliable-punctual.webp";

const ShuttleServices = () => {
  return (
    <div>
      <div className="inner-banner">
        <Container>
          <Row>
            <Col xs={12} md={7}>
              <div className="contact-banner pt-80">
                <h4>SHUTTLE SERVICES</h4>
                <p className="pr-50">
                  Our shuttle service cuts down the challenges of waiting for a bus or negotiating with auto drivers. With our shuttle service, employees can comfortably commute to their workplace. We offer AC and non-AC shuttle services with a mobile application enabled for tracking. No matter which service you choose, our buses are well-maintained, clean, and hygienic. Not to worry, our drivers are well-versed with all the routes and trained to follow the assigned routes efficiently. Through our best-in-class services, we aim to provide you with a memorable travel experience.
                </p>
              </div>
            </Col>
            <Col xs={12} md={5} className="pr-0">
              <img src={s2} className="img-fluid img-animation" alt=""></img>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="section">
        <Container>
          <Row>
            <Col xs={12} md={12}>
              <div className="main-title text-center">
                <h4>
                  We provide safe and comfortable employee transportation
                  service
                </h4>
                <div className="divider-center"></div>
              </div>
            </Col>
          </Row>
          <Row className="mt-60">
            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={experienced} className="img-fluid" alt=""></img>
                <h6>EXPERIENCED DRIVERS</h6>
                <p>
                  Our drivers are experienced and highly professional. They are well-versed in route navigation and use advanced systems through a mobile application enabled for tracking to follow shorter and traffic-free routes. From boarding to de-boarding, our drivers ensure the utmost safety of the passengers.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={comfortable} className="img-fluid" alt=""></img>
                <h6>COMFORTABLE VEHICLES</h6>
                <p>
                  Give a pleasant travel experience to your employees with
                  Hive Employee Transportation And Cab Services shuttle service. When your employees travel
                  comfortably and safely, they tend to be happier and more
                  productive. We carefully monitor and check our vehicles to
                  ensure that they are in good condition.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={tracking} className="img-fluid" alt=""></img>
                <h6>REAL-TIME TRACKING</h6>
                <p>
                  All our buses are equipped with a mobile application enabled for tracking. You and your employees can track the bus location in real-time and also share it with others.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={eco} className="img-fluid" alt=""></img>
                <h6>ECO-FRIENDLY</h6>
                <p>
                  When employees travel together, they reduce carbon footprint
                  and save our environment.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={ontime} className="img-fluid" alt=""></img>
                <h6>ON-TIME</h6>
                <p>
                  We value your time and hence we adhere to punctuality. We
                  maintain a time schedule and all our buses depart and arrive
                  as per the schedule. Since our drivers take the route with
                  lesser traffic, the arrival time is more or less guaranteed as
                  per the schedule.
                </p>
              </div>
            </Col>

            <Col xs={12} md={4} data-aos="fade-up">
              <div className="service-cards pt-40">
                <img src={reliable} className="img-fluid" alt=""></img>
                <h6>RELIABLE</h6>
                <p>
                  With friendly staff, well-maintained buses, trained drivers,
                  and professional management of the services round the clock,
                  Hive Employee Transportation And Cab Services provides a reliable and dependable service.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default ShuttleServices;
